// extracted by mini-css-extract-plugin
module.exports = {"Set":"Notifications_Set__Zo5NW"};